/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterItemDto
 */
export interface FilterItemDto {
    /**
     * 
     * @type {string}
     * @memberof FilterItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FilterItemDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof FilterItemDto
     */
    code: string;
    /**
     * 
     * @type {number}
     * @memberof FilterItemDto
     */
    count: number;
}

/**
 * Check if a given object implements the FilterItemDto interface.
 */
export function instanceOfFilterItemDto(value: object): value is FilterItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function FilterItemDtoFromJSON(json: any): FilterItemDto {
    return FilterItemDtoFromJSONTyped(json, false);
}

export function FilterItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'code': json['code'],
        'count': json['count'],
    };
}

export function FilterItemDtoToJSON(json: any): FilterItemDto {
    return FilterItemDtoToJSONTyped(json, false);
}

export function FilterItemDtoToJSONTyped(value?: FilterItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'code': value['code'],
        'count': value['count'],
    };
}

